// LinkedIn post templates organized by category
const templates = {
  viral: [
    {
      id: 1,
      title: "Reflection",
      template: "Reflecting on {Topic}, I realized {Insight}.\nIt's not just about {Common Belief}, but more about {Personal Insight}.\nWhat's your experience with {Topic}?"
    },
    {
      id: 2,
      title: "Tips to Improve",
      template: "Looking to improve your {topic}? Here are {number} tips that have transformed my approach:\n{Tip 1}\n{Tip 2}\n{Tip 3}\nApply these to see a real difference in your {related area}. Let me know how they work out for you!"
    },
    {
      id: 3,
      title: "Myth Debunking",
      template: "Top 5 {Industry} Myths DEBUNKED 💥:\nMyth: {Common Misconception} – Truth: {Reality}.\nMyth: {Another Misbelief} – Truth: {Clarification}.\nMyth: {Popular Falsehood} – Truth: {Fact}.\nLet's clear the air – got more myths to bust?"
    },
    {
      id: 4,
      title: "Case Study",
      template: "Case Study: Transforming {Problem} into {Solution} 🔄\nChallenge: {Brief Challenge}\nAction: {Brief Action Taken}\nResult: {Brief Result}\nInsight? {Key Insight}.\nEver faced a similar situation? How did you handle it?"
    },
    {
      id: 5,
      title: "Success Reality",
      template: "Success isn't handed out; it's earned through hard choices and sacrifices. Here's a glimpse into the reality behind the glamour:\nChoosing Isolation for Focus: Sometimes, stepping away from the crowd means forging your own path.\nThe Sleepless Nights: Every dream pursued may mean hours of rest sacrificed.\nSaying No to Good to Say Yes to Great: Not every opportunity is the right one.\nThrough my journey, I've learned {Personal Lesson from Sacrifices}.\nWhat sacrifices have you made for your success?"
    },
    {
      id: 6,
      title: "Unpopular Opinion",
      template: "Here's something you might not hear often: {Unpopular Opinion}. 🚫\nWhy I stand by this:\n🤔 Controversial Point: {Detail}\n📈 Evidence: {Evidence Detail}\n🔄 Alternative Perspective: {Alternative Detail}\nWhat's your stance on {Topic}?"
    },
    {
      id: 7, 
      title: "Journey & Transformation",
      template: "From facing {Initial Failure, e.g., business failure} to now having {Success Metrics, e.g., 40k followers and a thriving business}, here's what I learned:\nEmbrace the growing pains; they're the secret ingredients to success.\nView every interaction as a stepping stone towards your goals.\nMaster the art of storytelling; it's your most powerful tool.\nRemember, the path to success is built on a bridge of struggles. Start building yours today.\nP.S. Ready to embark on your transformation journey? Here are some tips to get you started. Follow for more insights! 🚀"
    },
    {
      id: 8,
      title: "Industry Trends",
      template: "As we step into {Year}, let's delve into the emerging trends shaping our industry:\n{Trend 1}: What it means and how to adapt.\n{Trend 2}: Strategies for leveraging this development.\n{Trend 3}: Potential challenges and solutions.\nBut insights are more potent when shared:\n📈 What trends are you observing in our industry?\n📉 How are you planning to navigate these changes?"
    },
    {
      id: 9,
      title: "Milestone Alert",
      template: "🎉 Milestone Alert 🎉\nJust hit {Milestone}! Here's what it took:\n{Effort 1}\n{Effort 2}\nBeyond excited for what's next"
    },
    {
      id: 10,
      title: "Direct Opinion Challenge",
      template: "Unpopular opinion: {Your controversial opinion}.\n→ Here's why I think differently:\n{Explanation}\nLet's debate."
    },
    {
      id: 11,
      title: "Quirky Tips",
      template: "3 Quirky Tips for {Specific Task} that Actually Work 😜:\n{Odd but Effective Tip}.\n{Unexpected Hack}.\n{Surprising Shortcut}.\nBet you haven't heard these before!"
    },
    {
      id: 12,
      title: "Case Study with Hashtag",
      template: "Transforming {Problem} into {Solution} 🔄\nChallenge: {Brief Challenge}\nAction: {Brief Action Taken}\nResult: {Brief Result}\nInsight? {Key Insight}.\nEver faced a similar situation? How did you handle it? #CaseStudyCorner"
    },
    {
      id: 13,
      title: "Thought of the Day",
      template: "Today's Thought: {Brief Insight or Question} 🌿\nWhat's your take?"
    },
    {
      id: 14,
      title: "In-depth Journey",
      template: "Last {Timeframe}, I embarked on a journey that took me deep into the heart of {Complex Topic or Task}. It was more than just a learning curve; it was a rollercoaster of {Emotions/Challenges}.\nHere's what I did:\n{In-depth Step 1} - {Explanation}.\n{In-depth Step 2} - {Explanation}.\n{In-depth Step 3} - {Explanation}.\nBut the real game-changer was when I {Key Turning Point}. That's when everything clicked.\n🎓 Major Takeaways:\n{Insight 1}\n{Insight 2}\n{Insight 3}\nThis journey taught me {Final Lesson}. If you're considering diving into {Complex Topic or Task}, my advice is {Piece of Advice}.\nEver tackled something similar? I'd love to hear your story and insights below! 👇"
    },
    {
      id: 15,
      title: "Period Reflection",
      template: "As {Time Period} comes to a close, I've taken a moment to reflect on my journey in {Field/Industry}:\nChallenges Conquered:\nFaced {Challenge} and learned {Lesson}.\nMilestones Achieved:\nCelebrated {Milestone} which taught me {Insight}.\nKnowledge Gained:\nDelved into {Topic} and discovered {Key Finding}.\nLooking Ahead:\nPlanning to {Future Goal} with {Strategy}.\nReflecting helps me appreciate the path traveled and prepare for the journey ahead. What are your key takeaways from {Time Period} in {Field/Industry}?"
    },
    {
      id: 16,
      title: "Business Evolution",
      template: "I made my first ${Amount} by doing {Activity}. After {Number of Rebrands}, here's how I keep evolving: 🌟\nKey pivots I made:\n🔄 {Change 1}\n🔄 {Change 2}\n🔄 {Change 3}\nChange is the only constant. Embrace it by {Personal Advice}. 🌱"
    },
    {
      id: 17,
      title: "Perspective Change",
      template: "There was a time when {Event/Challenge} completely changed my perspective. 🌟\nThe journey:\n🔄 Transition: {Transition Detail}\n🎢 Challenge: {Challenge Detail}\n🌈 Revelation: {Revelation Detail}\nThis experience showed me {Key Lesson}. 🌱\nP.S. Have you faced a similar turning point? I'd love to hear about it! 📖"
    },
    {
      id: 18,
      title: "Action to Result",
      template: "Here's my approach to turning a {Action} into {Result}:\n1️⃣ {Format 1} ➡️ {Brief Description}\n2️⃣ {Format 2} ➡️ {Brief Description}\n3️⃣ {Format 3} ➡️ {Brief Description}\nAnd remember, {Actionable Advice}! Let's make it happen. 📈"
    },
    {
      id: 19,
      title: "Lessons from Topic",
      template: "Learning comes in various forms. Here are {Number} ways {Topic} has taught me valuable lessons: 📚\n{Lesson 1}\n{Lesson 2}\n{Lesson 3}\nKey takeaway? {Concluding Thought}. 🗝️ #LearningFrom{Topic}"
    },
    {
      id: 20,
      title: "Mistake Reflection",
      template: "Oops, I did it again... 🙈\n🔻 Blunder: {Specific Failure}.\n🔺 Recovery: How I swallowed my pride and {Correction Action}.\n🔄 Reflection: Why this was a disguised blessing.\nYour turn – spill your 'oops' moment!"
    },
    {
      id: 21,
      title: "Myth Busting",
      template: "Myth Busting Time: {Common Myth} ❌\nTruth? {Actual Fact} ✅\nLet's spread the truth about {Topic}!"
    },
    {
      id: 22,
      title: "Years of Experience",
      template: "After {X} years in {field}, here's what I've learned:\n{Key learning}\n{Another important insight}\n{A surprising discovery}\nThis experience has taught me {key takeaway}."
    },
    {
      id: 23,
      title: "Failing Forward",
      template: "Failing forward is the key... 🛤️\n❌ Mistake: {Major Mistake}.\n🔄 Lesson: {What I Learned}.\n⏩ Next Steps: {How I Moved Forward}.\nEver experienced a similar setback? How did you bounce back? 💪"
    },
    {
      id: 24,
      title: "Today's Challenge",
      template: "Today's challenge: {Challenge Description}. It's all about {Purpose of Challenge}.\nTake a step towards {Goal} by doing {Actionable Step}. Who's joining me?"
    },
    {
      id: 25,
      title: "Personal Journey",
      template: "Once a {Old Profession, e.g., electrician}, working {Number} days a week, I was trapped in the cycle of earning without purpose.\nThen, I stumbled upon \"\"{Book}\"\" and realized the true meaning of life isn't just about making money but finding a deeper purpose.\nTo my fellow {Professionals}, remember:\nReflect on your past to uncover your true passion.\nLet your personal story guide your path to purpose.\nEmbrace the journey, for true freedom lies in understanding the bigger picture.\nYour story is the key to unlocking your potential. Let it guide you to content that not only resonates but fulfills.\n📖 What's your story? Share below."
    },
    {
      id: 26,
      title: "Celebration Time",
      template: "Did someone say 'Celebration Time'? 🍾\n🎖️ Achievement Unlocked: {What You Achieved}.\n🛠️ Behind the Scenes: The hustle was real {Brief Backstory}.\n🙌 Shout-Out: Big thanks to {Mentions} – couldn't have done it without ya!"
    },
    {
      id: 27,
      title: "Adversity Lessons",
      template: "Facing {Adversity/Challenge} was not easy, but it taught me invaluable lessons:\n{Lesson One or Strategy Used}\n{Lesson Two or Strategy Used}\n{Lesson Three or Strategy Used}\nThis experience shaped me into a more {Adjective} individual/professional. How have you turned your struggles into strength?"
    },
    {
      id: 28,
      title: "Ruthless Growth",
      template: "Unpopular opinion: Top {Percentage}%? It's about ruthlessness. 🚫\nSometimes, you gotta leave:\n{Common Thing 1}\n{Common Thing 2}\nSacrifice = Growth. Ready to step up? 📈"
    },
    {
      id: 29,
      title: "Achievement Alert",
      template: "Big moment alert: {Achievement/Event} is a reality! 🥳\nShoutouts:\n🌟 Star Player: {Factor Detail}\n📈 Growth: {Factor Detail}\n💖 Support: {Factor Detail}\nYour turn! What's something you've recently achieved?"
    },
    {
      id: 30,
      title: "Engagement Blueprint",
      template: "Boosting engagement in just {Time} daily? Here's the blueprint: 🔍\n💬 Respond to comments\n🤝 Connect with your peeps\n🔗 Network with leaders\nStart with {Simple Action}. Watch the magic happen. 🌟"
    },
    {
      id: 31,
      title: "Challenge Tackling",
      template: "Facing challenges is part of growth. Here's how I tackled {specific challenge}:\n{Understanding the challenge}\n{Strategies I employed}\n{Outcome and lessons learned}\nChallenges like {specific challenge} have taught me {key learning}."
    },
    {
      id: 32,
      title: "Top 3 Tips",
      template: "Top 3 Tips for {Topic} Success: 🏆\n{Tip 1}: {Brief Explanation}.\n{Tip 2}: {Brief Explanation}.\n{Tip 3}: {Brief Explanation}.\nGot a tip to add? Drop it below! 👇"
    },
    {
      id: 33,
      title: "Brand Reinvention",
      template: "Reinventing from {Old Brand} to {New Brand} wasn't just change, it was growth. 🔄\nEach phase taught me {Lesson}.\nYour brand = Your story. How are you writing yours? ✍️"
    },
    {
      id: 34,
      title: "Mistakes & Lessons",
      template: "Everyone makes mistakes, but here are {X} I made and what I learned:\n❌{Mistake 1} - The lesson: ✅ {lesson learned}.\n❌{Mistake 2} - What I now understand: ✅ {new understanding}.\n❌{Mistake 3} - How I improved: ✅ {corrective action}."
    },
    {
      id: 35,
      title: "Challenge Solutions",
      template: "Facing {Common Challenge}? You're not alone. 🚧\nHere's how I tackled it:\n{Solution Step 1}\n{Solution Step 2}\n{Solution Step 3}\nOvercome challenges by {Final Advice}. Your thoughts? #ChallengeAccepted"
    },
    {
      id: 36,
      title: "Tools of Trade",
      template: "In my {X} years in {field}, I've used numerous tools. Here are the top {X}:\n1️⃣ {Tool 1} - Great for {purpose}.\n2️⃣{Tool 2} - I love it for {reason}.\n3️⃣{Tool 3} - Essential for {specific task}.\nThese tools have been invaluable for {overall benefit}."
    },
    {
      id: 37,
      title: "Journey Timeline",
      template: "📖 My Journey with {Topic} 📖\nBack in {Year}, I {Starting Point}. Fast forward to now, {Current Situation}. Here's what happened in between:\n🌟 {Milestone/Obstacle 1}\n🌟 {Milestone/Obstacle 2}\n🌟 {Milestone/Obstacle 3}\nThe biggest lesson learned? {Key Lesson}.\nHas {Topic} shaped your journey too? Share your story below! #StoryTime"
    },
    {
      id: 38,
      title: "Aspect Boosting",
      template: "Boost your {Aspect} with these tried and tested tips: ✔️\nStrategies:\n🎯 Tip: {Tip Detail}\n🔗 Connection: {Connection Detail}\n🚀 Implementation: {Implementation Detail}\nGot any game-changing {Topic} tips?"
    },
    {
      id: 39,
      title: "Essential Tools",
      template: "In my {experience} with {topic}, I've found these tools indispensable:\n{Tool 1} for {use case}\n{Tool 2} for {use case}\nSharing these to help streamline your {related task}. What tools do you swear by?"
    },
    {
      id: 40,
      title: "Topic Myths",
      template: "There are many myths about {topic}, but here are the top {X} I've encountered:\n1.{Myth 1} - But in reality, {truth}.\n2.{Myth 2} - The truth is, {actual fact}.\n3.{Myth 3} - Actually, {real situation}.\nLet's dispel these myths and focus on {actionable advice}."
    },
    {
      id: 41,
      title: "Must-Know Facts",
      template: "Quick facts about {Topic} that every {Professional} should know:\n📊 {Fact 1}: {Brief explanation}\n🔎 {Fact 2}: {Brief explanation}\n💡 {Fact 3}: {Brief explanation}\nWhich of these surprised you the most? #FactCheck"
    },
    {
      id: 42,
      title: "Scaling Insights",
      template: "Scaling {Business/Product/Service} from {Number} to {Larger Number}? Here's my playbook: 📈\n{Strategy 1}: {Brief elaboration}\n{Strategy 2}: {Brief elaboration}\n{Strategy 3}: {Brief elaboration}\nWhat strategy are you implementing to scale? Let's discuss! #ScalingUp"
    },
    {
      id: 43,
      title: "Transition Story",
      template: "My transition from {Previous Role/Industry} to {Current Role/Industry} taught me {Number} valuable lessons:\n1⃣ {Lesson 1}: {Brief explanation}\n2⃣ {Lesson 2}: {Brief explanation}\n3⃣ {Lesson 3}: {Brief explanation}\nThinking of making a similar transition? Feel free to ask questions below! #CareerTransition"
    },
    {
      id: 44,
      title: "Productivity Framework",
      template: "My 3-step productivity framework for {Task/Goal}: ⚡\n⏰ {Step 1}: {Time Management Technique}\n🎯 {Step 2}: {Focus Strategy}\n📊 {Step 3}: {Evaluation Method}\nImplement this for {X} weeks and watch your efficiency soar! What's your productivity hack? #ProductivityTips"
    },
    {
      id: 45,
      title: "Self-discovery Question",
      template: "A thought-provoking question that changed my perspective: {Question}? 🤔\nIt led me to realize {Insight}, which transformed how I approach {Aspect of Life/Business}.\nWhat question has shifted your thinking lately? #MindsetShift"
    },
    {
      id: 46,
      title: "Professional Growth",
      template: "Growth in your {profession/industry} isn't linear. Here are {X} pivotal moments that accelerated mine:\n🌱 {Moment 1}: {Brief story and impact}\n🌳 {Moment 2}: {Brief story and impact}\n🌲 {Moment 3}: {Brief story and impact}\nWhat's been your most significant professional growth catalyst? #ProfessionalDevelopment"
    },
    {
      id: 47,
      title: "Question-Based Engagement",
      template: "Curious: How do you approach {Common Challenge in Industry}? 🧐\nI've found {Your Approach} works well because {Reason}, but I'm always looking to improve my process!\nShare your strategies below - let's learn from each other! #IndustryInsights"
    },
    {
      id: 48,
      title: "Counterintuitive Success",
      template: "The most counterintuitive advice that helped me succeed in {Field}: {Advice}. 🔄\nWhy it works:\n💭 {Reason 1}: {Explanation}\n💭 {Reason 2}: {Explanation}\n💭 {Reason 3}: {Explanation}\nSometimes, the unexpected approach yields the best results. What counterintuitive strategy has worked for you? #SuccessTips"
    },
    {
      id: 49,
      title: "Knowledge Sharing",
      template: "{Number} things I wish I knew before starting in {industry/role}:\n1⃣ {Insight 1}: {Explanation}\n2⃣ {Insight 2}: {Explanation}\n3⃣ {Insight 3}: {Explanation}\nHope this helps someone just starting out! What would you add to this list? #CareerAdvice"
    },
    {
      id: 50,
      title: "Insider Perspective",
      template: "The {industry} looks glamorous from the outside, but here's what it's really like:\n👉 {Reality Check 1}: {Explanation}\n👉 {Reality Check 2}: {Explanation}\n👉 {Reality Check 3}: {Explanation}\nDespite these challenges, I love what I do because {Reason}. Any fellow {industry professionals} relate? #InsiderPerspective"
    },
    {
      id: 51,
      title: "Book Impact",
      template: "The book that fundamentally changed my approach to {Topic/Area}: \"{Book Title}\" by {Author}. 📚\nKey takeaways:\n📝 {Takeaway 1}: {Brief explanation}\n📝 {Takeaway 2}: {Brief explanation}\n📝 {Takeaway 3}: {Brief explanation}\nHave you read it? Or what book has influenced you most? #BookRecommendation"
    },
    {
      id: 52,
      title: "Skill Development",
      template: "Developing {Skill} has been transformative for my career. Here's how I did it:\n🔍 Discovery: {How you identified the need}\n📈 Progress: {How you improved}\n🔑 Mastery: {How you applied it}\nThis skill has helped me {Specific Benefit}. What skill has been most valuable in your journey? #SkillDevelopment"
    },
    {
      id: 53,
      title: "Habit Formation",
      template: "The {morning/daily/weekly} habit that transformed my {productivity/creativity/wellbeing}: {Habit Description}. ⏰\nHow it works:\n🔄 Process: {How you implement it}\n⚡ Impact: {The difference it makes}\n🌟 Results: {Tangible outcomes}\nConsistency is key! What's a game-changing habit in your routine? #HabitBuilding"
    }
  ],
  professional: [],
  engagement: []
};

export default templates; 